const principles = [
  { icon: 'ri-check-double-line', title: '先核实后还原', desc: '每条实况都需经过多方信源交叉核对，杜绝把猜测当成事实呈现。' },
  { icon: 'ri-list-check-3', title: '还原完整链条', desc: '不止给一个片段，尽量还原事件起因、经过与各方态度，把来龙去脉讲完整。' },
  { icon: 'ri-empathize-line', title: '理性围观为上', desc: '鼓励吃瓜，更鼓励独立思考。我们拒绝造谣传谣，也拒绝无意义站队。' },
  { icon: 'ri-lifebuoy-line', title: '欢迎纠错共建', desc: '若有事实出入欢迎随时指正，我们会第一时间核对并更正，让瓜田越耕越实。' },
];

const testimonials = [
  { quote: '每天睡前刷一刷，信息量刚刚好。它们把我看不懂的热搜讲得明明白白，还教我怎么避开假瓜。', name: '@林间小鹿', role: '资深围观者' },
  { quote: '做深度还原那几篇很顶，时间线一拉出来，反转前后的脉络瞬间就清楚了，吃瓜都吃出了课代表的感觉。', name: '@吃瓜不放糖', role: '夜猫子冲浪选手' },
  { quote: '难得的是这里会提醒“先别急着站队”，讲证据也讲常识。关注久了，自己也慢慢学会理性看热闹了。', name: '@南山Observer', role: '新晋吃瓜人' },
];

export default function About() {
  return (
    <section id="about" className="w-full scroll-mt-24 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-10">
          {/* narrative */}
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-accent-600">
              <i className="ri-compass-3-line" aria-hidden="true" /> ABOUT US
            </p>
            <h2 className="mt-2 font-display text-2xl font-black md:text-3xl">吃瓜现场，想把热闹吃明白</h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700">
              吃瓜现场是一处面向全网吃瓜群众的围观平台，专注于热点事件的现场直击与实况还原。面对每天涌入的海量热点与碎片信息，我们希望提供的不是煽动情绪的标题，而是一条条经过整理的、可被信源支撑的事件脉络。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              从最初几个朋友在群里分享“今天又吃到了什么瓜”，到如今聚集了数十万愿意理性围观的朋友，我们始终相信：看热闹只是入口，把热闹背后的来龙去脉看清楚，才是一个真正舒服的围观现场。
            </p>

            <div className="mt-6 flex items-center gap-4 rounded-2xl bg-accent-100 p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-500 text-background-50"><i className="text-lg ri-mail-send-line" aria-hidden="true" /></span>
              <div>
                <p className="font-display text-sm font-bold text-accent-900">线索投稿与合作</p>
                <a href="mailto:hello@guachang.online" className="text-sm text-accent-800 underline-offset-4 hover:underline">hello@guachang.online</a>
              </div>
            </div>
          </div>

          {/* principles */}
          <div className="grid content-start gap-4 sm:grid-cols-2">
            {principles.map((p) => (
              <div key={p.title} className="rounded-2xl bg-background-100 p-5 transition-colors hover:bg-background-200/70">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-secondary-200 text-secondary-900"><i className={`text-lg ${p.icon}`} aria-hidden="true" /></span>
                <h3 className="mt-3 font-display text-sm font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-1.5 text-sm leading-6 text-foreground-600">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* testimonials */}
        <div className="mt-12">
          <div className="flex items-center justify-between">
            <h3 className="font-display text-lg font-bold md:text-xl">来自围观群众的真实口碑</h3>
            <span className="flex items-center gap-1 text-sm text-secondary-700"><i className="ri-emotion-line" aria-hidden="true" /> 数十万吃瓜人的选择</span>
          </div>
          <div className="mt-5 grid gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col rounded-2xl bg-background-100 p-5">
                <div className="flex gap-0.5 text-secondary-500" aria-label="五星好评">
                  {Array.from({ length: 5 }).map((_, i) => <i key={i} className="ri-star-fill text-sm" />)}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-7 text-foreground-700">“{t.quote}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-2.5 border-t border-background-200 pt-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">{t.name[1]}</span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-950">{t.name}</span>
                    <span className="block text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}